import { render, staticRenderFns } from "./PromoAggregatorHeader.vue?vue&type=template&id=2861ddf5&scoped=true&lang=pug"
import script from "./PromoAggregatorHeader.vue?vue&type=script&lang=js"
export * from "./PromoAggregatorHeader.vue?vue&type=script&lang=js"
import style0 from "./PromoAggregatorHeader.vue?vue&type=style&index=0&id=2861ddf5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2861ddf5",
  null
  
)

export default component.exports